/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeagueRosterMemberResponse
 */
export interface LeagueRosterMemberResponse {
    /**
     * 
     * @type {string}
     * @memberof LeagueRosterMemberResponse
     */
    odId: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueRosterMemberResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueRosterMemberResponse
     */
    role: string;
    /**
     * 
     * @type {number}
     * @memberof LeagueRosterMemberResponse
     */
    joinedAt: number;
}

/**
 * Check if a given object implements the LeagueRosterMemberResponse interface.
 */
export function instanceOfLeagueRosterMemberResponse(value: object): value is LeagueRosterMemberResponse {
    if (!('odId' in value) || value['odId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('joinedAt' in value) || value['joinedAt'] === undefined) return false;
    return true;
}

export function LeagueRosterMemberResponseFromJSON(json: any): LeagueRosterMemberResponse {
    return LeagueRosterMemberResponseFromJSONTyped(json, false);
}

export function LeagueRosterMemberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueRosterMemberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'odId': json['odId'],
        'displayName': json['displayName'],
        'role': json['role'],
        'joinedAt': json['joinedAt'],
    };
}

export function LeagueRosterMemberResponseToJSON(json: any): LeagueRosterMemberResponse {
    return LeagueRosterMemberResponseToJSONTyped(json, false);
}

export function LeagueRosterMemberResponseToJSONTyped(value?: LeagueRosterMemberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'odId': value['odId'],
        'displayName': value['displayName'],
        'role': value['role'],
        'joinedAt': value['joinedAt'],
    };
}

